/* eslint-disable import/no-named-as-default */
/* eslint-disable max-len */

import React from 'react';
import { connect } from 'react-redux';

import { fetchAutoMessages, setAutoSmsByMonth, showAutoMsgDetails, sortAutoMessages, sortAutoMsgClient, sortAutoSmsByMonth } from 'clientCommunications/actions';
import AutoMessagesComponent from 'clientCommunications/components/Automate/AutoMessages';
import AutoMessagesHeader from 'clientCommunications/components/Automate/AutoMessagesHeader';
import { trackEvent } from 'tracking/actions';

class AutomatedMessagesLayout extends React.Component {
  componentDidMount() {
    this.props.fetchAutoMessages(this.props.salonId);
  }

  showContent = (id, show) => {
    this.props.showAutoMsgDetails(this.props.salonId, id, show);
  };

  render() {
    return (
      <>
        <div className="automate-container">
          <div className="sticky-container-automsg">
            <AutoMessagesHeader sortFunction={this.props.sortAutoSmsByMonth} sortAutoSmsByMonth={this.props.sortAutoSmsByMonth} />
            {this.props.autoMessages && this.props.autoSmsByMonth && (
              <AutoMessagesComponent
                showContent={this.showContent}
                sortFunction={this.props.sortAutoMessages}
                autoSmsByMonth={this.props.autoSmsByMonth}
                groupOrderChanged={this.props.groupOrderChanged}
              />
            )}
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  salonId: state.currentSalon.id,
  autoMessages: state.clientCommunications.autoMessages,
  autoSmsByMonth: state.clientCommunications.autoSmsByMonth,
  groupOrderChanged: state.clientCommunications.groupOrderChanged,
});

function mapDispatchToProps(dispatch) {
  return {
    fetchAutoMessages(salonId) {
      dispatch(fetchAutoMessages(salonId));
    },
    showAutoMsgDetails(salonId, campaignId, show) {
      dispatch(showAutoMsgDetails(salonId, campaignId, show));
    },
    sortAutoMessages(row, isAsc, campaignId) {
      dispatch(sortAutoMessages(row, isAsc, campaignId));
    },
    sortAutoMsgClient(row, isAsc, messageId) {
      dispatch(sortAutoMsgClient(row, isAsc, messageId));
    },
    trackEvent(event, properties) {
      dispatch(trackEvent(event, properties));
    },
    setAutoSmsByMonth(autoSmsByMonth) {
      dispatch(setAutoSmsByMonth(autoSmsByMonth));
    },
    sortAutoSmsByMonth(row, isAsc) {
      dispatch(sortAutoSmsByMonth(row, isAsc));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AutomatedMessagesLayout);
